common.View.create('canvas.blocks.custom.accordion.Block', {
    onDOMLoad() {
        this.initScrollOnOpen();
    },

    initScrollOnOpen() {
        // Find the accordion items
        let accordionItem = this.element.find('.accordion-item');

        // Check if clicked
        accordionItem.on('click', (e) => {
            // Wait for animation to end
            setTimeout(() => {
                // Check if element is in viewport
                if (!this.checkVisible(e.currentTarget)) {
                    // Animate scroll
                    $('html, body').animate(
                        {
                            // Scroll to element
                            scrollTop: $(e.currentTarget).offset().top - 45,
                        },
                        250
                    );
                }
            }, 200);
        });
    },

    checkVisible(element) {
        // Get element box
        let rect = element.getBoundingClientRect();

        // Get view height
        let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

        // Calculate spacing
        let elementSpacing = viewHeight - 100;

        // Return boolean if element is in view
        return !(rect.bottom < 0 || rect.top - elementSpacing >= 0);
    },
});
